export const DroopyPlant = (props: any) => {
  return (
    <svg width={396} height={560} fill="none" {...props} viewBox="0 0 396 560">
      <ellipse
        opacity={0.6}
        cx={219.638}
        cy={535.062}
        rx={175.511}
        ry={24.063}
        fill="url(#prefix__paint0_radial_56:107)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.054 328.113s-10.702 89.555 30.698 126.11c54.932 48.503 106.633 33.953 106.633 33.953v33.952s1.616 12.934 14.541 12.934 12.925-12.934 12.925-12.934V352.365s53.971 5.297 96.94-29.102c50.086-40.096 35.545-130.96 35.545-130.96s-44.758-6.157-79.168 3.234c-35.544 9.701-53.317 32.336-53.317 32.336s-.005-122.877 0-124.493c.197-56.588-11.309-114.793-88.861-100.242-63.777 11.967-58.162 124.493-58.162 124.493s-60.996 22.857-79.167 67.906c-18.172 45.049 21.002 127.726 21.002 127.726s88.148-30.919 103.404-74.373c21.002-59.821-17.772-121.259-17.772-121.259s-6.465-95.39 45.236-97.007c40.372-1.263 46.854 32.336 46.854 53.354V370.15s-17.772-27.485-54.932-37.186c-37.913-9.897-82.399-4.85-82.399-4.85zM29.895 205.237c22.62-45.27 67.86-54.971 67.86-54.971s22.618 45.27 9.692 84.073c-13.096 39.315-69.472 58.205-69.472 58.205s-23.383-56.681-8.08-87.307zm226.194 37.186c-29.112 20.393-24.234 82.456-24.234 82.456s53.316 4.851 82.398-24.251c31.516-31.538 24.235-84.073 24.235-84.073s-33.929-8.084-82.399 25.868zM92.907 352.365s53.705-1.226 79.168 19.401c33.929 27.486 30.698 90.541 30.698 90.541s-48.47 4.85-85.631-27.486c-25.18-21.911-24.235-82.456-24.235-82.456z"
        fill="#CECDCE"
      />
      <defs>
        <radialGradient
          id="prefix__paint0_radial_56:107"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0 24.0625 -175.511 0 219.638 535.062)"
        >
          <stop stopColor="#282726" stopOpacity={0.35} />
          <stop offset={1} stopColor="#C4C4C4" stopOpacity={0} />
        </radialGradient>
      </defs>
    </svg>
  )
}
